import $ from 'jquery';

class Search {
     
    constructor() {
        this.addSearchHTML();
        this.resultsDiv = $("#search-overlay__results");
        this.openButton = $(".js-search-trigger");
        this.closeButton = $(".search-overlay__close");
        this.searchOverlay = $(".search-overlay");
        this.searchField = $("#search");
        this.events();
        this.isOverlayOpen = false;
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
    }

    events() {
        this.openButton.on("click", this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));
        $(document).on("keydown", this.keyPressDispatcher.bind(this));
        this.searchField.on("keyup", this.typingLogic.bind(this));
    }
    
    keyPressDispatcher(e) {
        if(e.keyCode==83 && !this.isOverlayOpen)
        {
            this.openOverlay();
        }

        if(e.keyCode==27 && this.isOverlayOpen)
        {
            this.closeOverlay();
        }
    }

    typingLogic() {
        if(this.searchField.val() != this.previousValue) {
            clearTimeout(this.typingTimer);

            if(this.searchField.val()) {
                if(!this.isSpinnerVisible) {
                    this.resultsDiv.html('<center><div class="spinner-loader"></div></center>');
                    this.isSpinnerVisible = true;
                }
            this.typingTimer = setTimeout(this.getResults.bind(this), 1000);
            } else {
                this.resultsDiv.html('');
                this.isSpinnerVisible = false;
            }

            
        }
        
        this.previousValue = this.searchField.val();
        
    }
    
    getResults() {
        $.when(
            $.getJSON(zzopData.root_url +'/wp-json/wp/v2/posts?search=' + this.searchField.val()),
            $.getJSON(zzopData.root_url +'/wp-json/wp/v2/pages?search=' + this.searchField.val())
            ).then((posts, pages) => {
            var combinedResults = posts[0].concat(pages[0]);
            this.resultsDiv.html(`
            ${combinedResults.length ? '<h2 class="search-overlay__section-title">Wyniki</h2><ul class="link-list min-list">' : '<h2 class="search-overlay__section-title">Nie znaleziono wyników</h2>'}
                ${combinedResults.map(item => `<li><a href="${item.link}">${item.title.rendered}</a></li>`).join('')}
            ${combinedResults.length ? '</ul>' : ''}
            `);
            this.isSpinnerVisible = false;
        }, () => {
            this.resultsDiv.html('<p class="search-overlay__section-title">Błąd wyszukiwania - spróbuj ponownie<p>')
        });

    }

    openOverlay() {
        this.searchOverlay.addClass("search-overlay--active");
        $("body").addClass("body-no-scroll");
        this.searchField.val('');
        setTimeout(()=>{this.searchField.focus()},301);
        this.isOverlayOpen = true;
    }

    closeOverlay() {
        this.searchOverlay.removeClass("search-overlay--active");
        $("body").removeClass("body-no-scroll");
        this.isOverlayOpen = false;
    }

    addSearchHTML() {
        $("body").append(`    
        <div class="search-overlay">
        <div class="search-overlay__top"></div>
          <div class="container">
              <i class="fa fa-search search-overlay__icon" style="font-size:48px;" aria-hidden="true"></i>
              <input type="text" class="search-term" placeholder="Wpisz szukaną frazę" id="search">
              <i class="fa fa-window-close search-overlay__close" style="font-size:48px;" aria-hidden="true"></i>
          </div>
  
        <div class="container">
            <div id="search-overlay__results"></div>
        </div>
      </div>`);
    }

}

export default Search;